import { CodedError } from './CodedError';
import { errorCodes } from './constants/errorCodes';

export default class PhoneVerificationBlockedError extends CodedError {
  static get errorName() {
    return errorCodes.phoneVerificationBlockedError.code;
  }

  constructor(
    message: string = errorCodes.phoneVerificationBlockedError.message
  ) {
    super(message);
    this.code = errorCodes.phoneVerificationBlockedError.code;
    this.status = errorCodes.phoneVerificationBlockedError.status;
    this.message = `${message} ${errorCodes.phoneVerificationBlockedError.code}`;
    this.name = errorCodes.phoneVerificationBlockedError.name;
  }
}
